module.exports = __webpack_public_path__ + "static/media/video-call-blue-icon.6935c8e5.svg";